<template>
    <div>
        <el-checkbox v-model="check" @change="updateStore">{{
            $l10n.__('Rapprocher')
        }}</el-checkbox>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapGetters: reconciliationGetters, mapMutations: reconciliationMutations } =
    createNamespacedHelpers('reconciliationStore');

export default {
    props: ['default', 'document', 'reference', 'amount', 'pay_type'],
    data() {
        return {
            check: this.default,
            uniqueId: '',
        };
    },
    computed: {
        ...reconciliationGetters(['transactionDate']),
    },
    methods: {
        ...reconciliationMutations(['addReconciled', 'delReconciled']),
        updateStore: function (check) {
            if (check) {
                const reconciliation = {
                    id: '_' + Math.random().toString(36).substr(2, 9),
                    ref: this.reference,
                    date: this.transactionDate,
                    amount: this.amount,
                    document: this.document,
                    pay_type: this.pay_type,
                };
                this.uniqueId = reconciliation.id;
                this.addReconciled(reconciliation);
                this.$emit('new-payment-confirmed');
            } else {
                this.delReconciled(this.uniqueId);
                this.uniqueId = '';
            }
        },
    },
};
</script>
